
// La conexión la diferencia dependiendo el ambiente en el que esté
const ApiHostName = window.location.hostname+'/api';
	/*window.location.hostname.indexOf('imsa.com.gt') >= 0
		? window.location.hostname
				.replace('proveedor.imsa.com.gt', 'api.proveedor.imsa.com.gt')
		: ((window.location.hostname.indexOf('local') >= 0)||(window.location.hostname.indexOf('celular')))
		? 'api.' + window.location.hostname
		: 'api.vvimsa.dev.glifos.net';*/

//console.log('ApiHostName:' + ApiHostName);
const ApiURLs = {
	publicFilesURL: 'https://'+ApiHostName+'/v1/',
	baseURL: window.location.protocol + '//' + ApiHostName + '/v1/',
	ProveedorSignUp: {
		href: '/user/signup',
		method: 'post'
	},
	ProveedorForgot: {
		href: '/user/forgot/proveedor',
		method: 'post'
	},
	ProveedorAccess: {
		href: '/user/access/proveedor',
		method: 'post'
	},
	UserLogin: {
		href: '/auth/authenticate/proveedor',
		method: 'post',
		requires: ['username', 'password', 'remember'],
	},
	documentTypes: {
		href: '/api/tx/document-type',
		method: 'get',
	},
	GetCatalogs:{
		href: '/api/tx/list-catalogs',
		method: 'get',
	},
	GetEnterprises: {
		href: '/api/tx/list-enterprises',
		method: 'get',
	},
	RegistrarFacturasPapel: {
		href: '/api/tx/registro-facturas-papel',
		method: 'post',
	},
	RegistrarRecibosPapel: {
		href: '/api/tx/registro-recibos-papel',
		method: 'post',
	},
	ListarDocumentosPapel:{
		href: '/api/tx/list-documentos-papel',
		method: 'get'
	},
	EliminarTramite:{
		href: '/api/tx/eliminar-tramite-proveedor',
		method: 'post',
		requires: ['dossier_id'],
	}
	,
	DetalleDossier:{
		/*href: '/api/tx/dossier-detail',*/
		href: '/api/tx/tramite-detalle-proveedor',
		method: 'post'
	},
	CrearLoteDigitalizacion:{
		href: '/api/tx/crear-lote-digitalizacion',
		method: 'post'
	},
	DetalleLote:{
		href: '/api/tx/lote-detalle',
		method: 'post'
	},
	RetornarLote:{
		href: '/api/tx/retornar-lote',
		method: 'post'
	},
	ListUserLots:{
		href: '/api/tx/list-user-lots',
		method: 'post'
	},
	OneLotDetail:{
		href: '/api/tx/one-lot-detail',
		method: 'post'
	},
	AcceptLot:{
		href: '/api/tx/accept-lot',
		method: 'post'
	},
	RejectLot:{
		href: '/api/tx/reject-lot',
		method: 'post'
	},
	UploadFile: {
		href: '/file/upload',
		method: 'post',
	},
	RequestAccessToFile: {
		href: '/file/request-access',
		method: 'post',
	},
	ListPendingDigitization: {
		href: '/api/tx/list-pending-digitization',
		method: 'post'
	},
	OneLotForDigitizationDetail:{
		href: '/api/tx/one-lot-digitization-detail',
		method: 'post'
	},
	AssociateDocumentToFile:{
		href: '/api/tx/associate-document-file',
		method: 'post'
	},
	FinalizeLot:{
		href: '/api/tx/finalize-lot',
		method: 'post'
	},	
	ValidarFEL: {
		href: '/api/tx/validar-fel',
		method: 'post',
		//urlParams: ['id'],
	},
	Msg:{
		href: '/message/get/:key',
		method: 'get'
	},
	AdvanceFetch:{
		href: '/advance/info/:type/:value',
		method: 'post'
	},
	NewTramite:{
		href: '/api/tx/new-tramite-proveedor',
		method: 'post'
	},
	NewTramiteRecibo:{
		href: '/api/tx/new-tramite-recibo-proveedor',
		method: 'post'
	},
	/*ListarMyTramites:{
		href: '/api/tx/list-my-tramites',
		method: 'post'
	},*/
	ListarMyTramites:{
		href: '/search/documents/proveedor',
		method: 'post'
	},
	ListarMyTramitesYaPagados:{
		href: '/api/tx/list-my-tramites-pagados',
		method: 'post'
	},
	SearchTramiteByDocumentId:{
		href: '/api/tx/proveedor-search-document-by-id',
		method: 'post'
	},
	SuggestedListNotificationAccounts:{
		href: '/api/tx/proveedor-get-notification-emails',
		method: 'post'
	},
	SpecializedSearchApi:{
		href: '/search/documentssearch/:type',
		method: 'post'
	}
};
//console.log(ApiURLs);
export default ApiURLs;
